import { render, staticRenderFns } from "./VerticalTab.vue?vue&type=template&id=d854bf42&scoped=true"
import script from "./VerticalTab.vue?vue&type=script&lang=js"
export * from "./VerticalTab.vue?vue&type=script&lang=js"
import style0 from "./VerticalTab.vue?vue&type=style&index=0&id=d854bf42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d854bf42",
  null
  
)

export default component.exports